module.exports = __webpack_public_path__ + "static/media/medium_circle_bg.acd61350.svg";